import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from './translation.service';

@Pipe({
    name: 'translate',
    standalone: false,
    pure: false
})

export class TranslatePipe implements PipeTransform {
    constructor(private translationService: TranslationService) {}

    transform(key: string): string {
        return this.translationService.getTranslation(key);
    }
}